<template lang="pug">
  .cover-page-container
    #cover-page.viva-page
      .layout.row.cover-header.wrap
        .flex.offset-md4.md8.xs12.title-program
          span ASU VIVA
      LineMultiColorHeaderSeparator
      .layout.row.cover-body.wrap
        .flex.md4
          .logoprogram
            img.asuparticipa-logo(src="@/assets/img/asuviva.png")
            .information-container
              .information.to-asuviva
                a(href="https://www.asuviva.com/" target="_blank") www.asuviva.com
              .information.to-download
                router-link(:to="{ name: 'asudownload', params: { page: 'viva' } }") Ver más información
        .flex.md8
          .description
            .description-header.center
              i.comillas.ap-comilla1
              h1.programs-page-title
                | El <strong>Plan Maestro</strong> de la Ciudad de <strong>Asunción</strong> busca una ciudad
                | <strong>reconciliada</strong> con su <strong>río</strong>, con su <strong>ambiente
                | natural</strong> y <strong>social</strong>, claves para una <strong>ciudad sostenible</strong>,
                | <strong>próspera</strong> y <strong>resiliente</strong>.
              i.comillas.ap-comilla2
            .description-body
              h2 El proyecto se basa en tres ejes temáticos:<br>
                | <span class="sub2">-Asunción y el Ambiente,</span> que busca salvaguardar
                | el
                | ecosistema natural con respecto al agua, suelo, aire, vegetación y fauna,
                | para potenciar el paisaje verde y respirar una ciudad más fresca.<br><br>
                | <span class="sub2">-Asunción y la Gente,</span> ligado al desarrollo junto
                | la
                | gente, por medio de la gobernanza, y la consolidación de espacios para una
                | vivienda digna.<br><br>
                | <span class="sub2">-Asunción y la Economía,</span> para un desarrollo
                | sostenible y sustentable en el tiempo, a través del uso eficiente del territorio, movilidad
                | sustentable y promoviendo el uso de las nuevas tecnologías.
              h3
                | <strong>ASU Participa</strong> impulsa <strong>
                | <a href="https://www.asuviva.com/" class="sub" target="_blank">ASU VIVA</a></strong>
                | porque
                | una ciudad inclusiva e inteligente, es posible.
    Footer
</template>
<script>
import goToHomeMixin from '@/mixins/go-back-home.js'

export default {
  mixins: [ goToHomeMixin ]
}
</script>
<style scoped lang="stylus">
@import '~@/styles/variables'

.cover-page-container
  margin: 100px 0 0 0

  .description-body
    h2
      line-height: 1.8rem

  #cover-page
    .information-container
      height: 5rem
      display: flex
      flex-direction: column
      justify-content: space-between
      margin-top: -5rem

    .logoprogram img
      margin-top: -75px

    .logoprogram-title
      margin-top: -95px

    .programs-page-title
      font-size: 1.6vw
      strong
        font-size: 1.6vw

</style>
